"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _Form = require("../Form");

var _reactSelect = require("react-select");

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-caret-down"
  }));
};

var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.ClearIndicator, props, /*#__PURE__*/_react.default.createElement("i", {
    className: "fas fa-times"
  }));
};

var Control = function Control(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactSelect.components.Control, props), /*#__PURE__*/_react.default.createElement("span", {
    className: "SelectField_border"
  }));
};

var SelectField = function SelectField(_ref) {
  var variant = _ref.variant,
      components = _ref.components,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["variant", "components"]);
  var isVariantFill = variant === 'fill';
  return /*#__PURE__*/_react.default.createElement(_.FieldWrapper, (0, _extends2.default)({}, otherProps, {
    noFieldBorder: true,
    alias: "SelectField",
    variant: variant,
    Field: _.Select,
    components: (0, _extends2.default)({}, isVariantFill ? {
      Control: Control
    } : {}, {
      DropdownIndicator: DropdownIndicator,
      ClearIndicator: ClearIndicator
    }, components || {})
  }));
};

SelectField.propTypes = (0, _extends2.default)({
  variant: _propTypes.default.string,
  components: _propTypes.default.object
}, _.Select.propTypes, _.FieldWrapper.propTypes);
SelectField.defaultProps = {
  variant: 'fill'
};
SelectField.displayName = 'SelectField';

var _default = (0, _Form.formalizer)(SelectField);

exports.default = _default;